export const Urls = {
    GetEntityValidationRules: "validations/GetEntityValidationRules",
    GetValidationRulesForLevel: "validations/GetValidationRules",
    SaveValidationRulesForLevel: "validations/SaveValidationRulesForLevel",
    GetValidationRootEntities: "validations/GetValidationRootEntities",
    ValidateChildEntity: "validations/validateChildEntity",
    Validate: "validations/validate"
};
